export const dialogMixin = {
  props: {
    event: {
      type: String,
    },
    /** @deprecated use `event` instead */
    triggerEventName: {
      type: String,
    },
    onInit: {
      type: Function,
      default: null
    },
    onShow: {
      type: Function,
      default: () => { }
    },
    onAdd: {
      type: Function,
      default: null
    },
    onEdit: {
      type: Function,
      default: null
    },
    onHide: {
      type: Function,
      default: () => { }
    },
    closeOnSave: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    editedItem: {},
    editOnly: false,
  }),

  computed: {
    isEditMode() {
      return this.editOnly || (this.editedItem && this.editedItem.id)
        ? true
        : false;
    },
    innerEventName() {
      return this.event || this.triggerEventName;
    }
  },

  created() {
    this.$eventHub.$on(this.innerEventName, this.open);
  },
  beforeDestroy() {
    this.$eventHub.$off(this.innerEventName, this.open);
  },

  methods: {
    // TODO: merge `triggerEventAction` and `triggerEventActionAsync`
    triggerEventAction(param) {
      this.editedItem = Object.assign({}, param);
    },
    async onAddAsync() { },
    async onEditAsync() { },

    //TODO: merge `onClose` and `onCloseAsync`
    onClose() { },
    async onCloseAsync() { },

    async open(param) {
      if (this.loadReferencesFn) {
        await this.loadReferencesFn(param);
      }
      if (this.onInit) {
        await this.onInit(param);
      } else if (this.triggerEventActionAsync) {
        await this.triggerEventActionAsync(param);
      } else {
        this.triggerEventAction(param);
      }
      this.dialog = true;
    },

    async close() {
      if (this.onHide) {
        this.onHide();
      }
      this.onClose();
      await this.onCloseAsync();
      this.dialog = false;

      setTimeout(() => {
        this.editedItem = {};
      }, 300);
    },

    async save() {
      if (this.isEditMode) {
        if (this.onEdit) {
          await this.onEdit(this.editedItem);
        } else {
          await this.onEditAsync(this.editedItem);
        }
      } else {
        if (this.onAdd) {
          await this.onAdd(this.editedItem);
        } else {
          await this.onAddAsync(this.editedItem);
        }
      }

      if (this.closeOnSave) {
        await this.close();
      }
    },
  },
};

export const getErrorMessage = (error) => {
  let emsg = JSON.stringify(error);
  if (error.response && error.response.data && error.response.data.items) {
    emsg = error.response.data.items[0].message;
  } else if (error.message) {
    emsg = error.message;
  }
  return emsg;
};